import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import countryCode from "../../../components/countryCode/countryCode.vue";
import _ from "lodash";
import { saveUserOrganizationAssociate, userUpdate } from "@/service/structure";
import LineOrgTag from "@/components/FragmentTemplate/LineOrgTag";
import ChangeOrg from "@/views/MGT/modal/ChangeOrg";
import ShowEncInput from "@/components/Common/ShowEncInput";
import { onInputRange } from "@/utils/util.js";
export default {
  name: "UserJoin",
  components: {
    LineOrgTag,
    ChangeOrg,
    ShowEncInput,
    countryCode
  },
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    },
    item: {
      type: null,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      onInputRange,
      accountType: "MOBILE",
      ruleCustom: {
        userSurname: [{
          required: true,
          message: $t("qi3qgc6", "姓氏不能为空")
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{1,60}$/,
          message: $t("e7tgsmo", "仅支持1-60个字符的字母,数字,汉字和部分符号")
        }],
        userGivenName: [{
          required: true,
          message: $t("9hq8pd5", "请填写名字")
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{1,60}$/,
          message: $t("e7tgsmo", "仅支持1-60个字符的字母,数字,汉字和部分符号")
        }],
        userNickname: [{
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,25}$/,
          message: $t("8veaw2o", "仅支持2-25个字符的字母,数字,汉字和部分符号"),
          trigger: "blur,change"
        }],
        userNumber: [{
          pattern: /^[a-zA-Z0-9\-\\_]{0,25}$/,
          message: $t("o1fa7fr", "仅支持字母、数字、符号_ 或 - 组成，长度25个以内")
        }],
        enc_email: [{
          validator: this.validEmail,
          trigger: "blur"
        }]
      },
      formObj: {
        mobileAreaCode: "+86",
        userSurname: "",
        userNickname: "",
        userGivenName: "",
        mobile: "",
        userEmail: "",
        enc_email: null,
        orgIds: "",
        userNumber: "",
        isAdmin: "F"
      },
      loading: false,
      title: $t("d76hme4", "新增成员"),
      scopeList: []
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    isEdit() {
      return this.item ? true : false;
    }
  },
  methods: {
    validMobile(rule, value, callback) {
      if (_.trim(value) === "") {
        callback(new Error($t("a2zp0d6", "请填写手机号")));
      } else {
        let reg = /^1[0-9]{10}$/;
        if (!reg.test(value)) {
          callback(new Error($t("tmaknjg", "手机号应为11位的数字,且1开头")));
        } else {
          callback();
        }
      }
    },
    validEmail(rule, value, callback) {
      console.log("value---", value);
      let reg = /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (typeof value != "object") {
        if (value && !reg.test(value)) {
          callback(new Error($t("venleq7", "邮箱格式不正确")));
        } else if (value.length > 50) {
          callback(new Error($t("venleq7", "邮箱格式不正确")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    async init() {
      this.title = $t("d76hme4", "新增成员");
      // 初始化部门
      this.setCheckTree();
      if (this.item) {
        // 截取formObj需要的字段值
        Object.keys(this.item).map(v => {
          if (Object.prototype.hasOwnProperty.call(this.formObj, v)) {
            if (v === "isAdmin") {
              this.formObj[v] = this.item[v] ? `${this.item[v]}` : "F";
            } else {
              this.formObj[v] = this.item[v] ? `${this.item[v]}` : "";
            }
          }
          return v;
        });
        this.title = $t("gmjx6r4", "编辑成员");
      }
    },
    setCheckTree() {
      if (this.item) {
        this.scopeList = this.item.organizations.map(v => {
          let arr = v.name.split("/");
          return {
            name: arr[arr.length - 1],
            orgId: v.orgId,
            type: "ORG"
          };
        });
      } else {
        this.scopeList = [{
          name: this.org.name,
          orgId: this.org.orgId,
          type: "ORG"
        }];
      }
      this.setIds(this.scopeList);
    },
    clean() {
      this.$refs["formCustom"].resetFields();
      this.formObj = {
        mobileAreaCode: "+86",
        userSurname: "",
        userNickname: "",
        userGivenName: "",
        mobile: "",
        userEmail: "",
        enc_email: null,
        orgIds: "",
        userNumber: "",
        isAdmin: "F"
      };
      // this.roleList = [];
    },
    cancel() {
      this.$emit("cancel");
    },
    submit(continu) {
      this.$refs["formCustom"].validate(valid => {
        if (valid) {
          //判断form中 邮箱和手机号是否有其中之一
          const {
            mobile,
            userEmail,
            enc_email
          } = this.formObj;
          if (this.isEdit) {
            if (!mobile && enc_email === "") {
              //没有手机号 且删除了邮箱
              this.$Message.error($t("2rqjy7c", "手机号和邮箱不能同时为空"));
            } else {
              this.onsubmitUpdate();
            }
          } else {
            this.$refs.countryCode.validate(valid => {
              if (valid) {
                if (!userEmail && !mobile) {
                  //手机号和邮箱同时为空
                  this.$Message.error($t("2rqjy7c", "手机号和邮箱不能同时为空"));
                } else {
                  this.onsubmitAdd(continu);
                }
              }
            });
          }
        }
      });
    },
    /*
     * 新增
     */
    async onsubmitAdd(continu) {
      const params = {
        ...this.formObj
      };
      this.loading = true;
      let res = await saveUserOrganizationAssociate(params);
      if (res.data && res.data.result === 0) {
        // await this.onSetRoleForUser(res.data.retVal);
        if (continu) {
          this.$Message.success($t("fhi9r8a", "新增成功, 继续添加"));
          this.saveContinu();
        } else {
          this.$Message.success($t("d76ha54", "新增成功"));
          this.$emit("update");
        }
      }
      this.loading = false;
    },
    /*
     * 更新
     */
    async onsubmitUpdate() {
      const params = {
        userId: this.item.userId,
        userSurname: this.formObj.userSurname,
        userNickname: this.formObj.userNickname,
        userGivenName: this.formObj.userGivenName,
        userNumber: this.formObj.userNumber,
        orgIds: this.formObj.orgIds,
        isAdmin: this.formObj.isAdmin,
        userEmail: typeof this.formObj.enc_email == "object" ? this.formObj.userEmail : this.formObj.enc_email,
        unitId: this.item.organizations.map(v => v.unitId).join(",")
      };
      this.loading = true;
      let res = await userUpdate(params);
      this.loading = false;
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("ai8d7e4", "修改成功"));
        this.$emit("update");
      }
    },
    setIds(checkTree) {
      let ids = [];
      checkTree.map(v => {
        ids.push(v.orgId);
      });
      this.formObj.orgIds = ids.join(",");
    },
    forEachCheckTree(checkTree) {
      checkTree.forEach(v => {
        v.type = "ORG";
      });
    },
    onChangeOrg(checkTree) {
      this.setIds(checkTree);
      this.forEachCheckTree(checkTree);
      this.scopeList = [...checkTree];
    },
    saveContinu() {
      this.clean();
      this.setCheckTree();
    },
    openModal(key) {
      switch (key) {
        case "addOrg":
          this.$refs["ChangeOrg"].open();
          break;
        default:
          break;
      }
    }
  }
};